<template>
  <v-card-text>
    <div v-if="missionManager.dashboardTools().isADCSMission(results)">
      <v-row>
        <v-col cols="4">
          <exo-mission-display-adcs
            :missionManager="missionManager"
            :results="results"
            :path="[]"
            :colorIndex="0"
            :expand="true"
          />
        </v-col>
        <v-col cols="4">
          <exo-mission-display-spacecraft
            :missionManager="missionManager"
            :results="results"
            label="Spacecraft"
            :path="['spacecraft']"
            :colorIndex="1"
            :expand="true"
          />
          <exo-mission-display-orbit
            :missionManager="missionManager"
            :results="results"
            label="Orbit"
            :path="['initialOrbit']"
            :colorIndex="2"
            :expand="true"
          />
        </v-col>
        <v-col cols="4">
          <exo-mission-display-sensor
            :missionManager="missionManager"
            :results="results"
            label="Sensors"
            :path="['spacecraft', 'sensors']"
            :colorIndex="6"
            :expand="true"
          />
          <exo-mission-display-magnetic-torquer
            :missionManager="missionManager"
            :results="results"
            label="Magnetic torquer"
            :path="['spacecraft', 'magneticTorquers']"
            :colorIndex="5"
            :expand="true"
          />
          <exo-mission-display-reaction-wheel
            :missionManager="missionManager"
            :results="results"
            label="Reaction Wheel"
            :path="['spacecraft', 'reactionWheels']"
            :colorIndex="4"
            :expand="true"
          />
          <exo-mission-display-thruster
            :missionManager="missionManager"
            :results="results"
            label="Propulsion system"
            :path="['spacecraft', 'thruster']"
            :colorIndex="3"
            :expand="true"
          />
        </v-col>
      </v-row>
    </div>
    <div
      class="d-flex"
      v-if="missionManager.dashboardTools().isPositioningMission(results)"
    >
      <v-col cols="4">
        <exo-mission-display-orbit-maneuver
          :missionManager="missionManager"
          :results="results"
          label="Orbital Transfer"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-spacecraft
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="1"
          :expand="true"
        />
        <exo-mission-display-thruster
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="2"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['maneuver', 'initialOrbit']"
          :colorIndex="3"
          :expand="true"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Final orbit"
          :path="['maneuver', 'finalOrbit']"
          :colorIndex="4"
        />
      </v-col>
    </div>
    <div
      class="d-flex"
      v-if="missionManager.dashboardTools().isRAANMission(results)"
    >
      <v-col cols="4">
        <exo-mission-display-raan-maneuver
          :missionManager="missionManager"
          :results="results"
          :label="'RAAN Phasing'"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-spacecraft
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="1"
          :expand="true"
        />
        <exo-mission-display-thruster
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="2"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['initialManeuver', 'initialOrbit']"
          :colorIndex="3"
          :expand="true"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Coasting orbit"
          :path="['initialManeuver', 'finalOrbit']"
          :colorIndex="4"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Final orbit"
          :path="['finalManeuver', 'finalOrbit']"
          :colorIndex="5"
        />
      </v-col>
    </div>
    <div
      class="d-flex"
      v-if="
        missionManager
          .dashboardTools()
          .isArgumentOfLatitudePhasingMission(results)
      "
    >
      <v-col cols="4">
        <exo-mission-display-aolphasing-maneuver
          :missionManager="missionManager"
          :results="results"
          label="Orbit Phasing"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-spacecraft
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="1"
          :expand="true"
        />
        <exo-mission-display-thruster
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="2"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['initialOrbit']"
          :colorIndex="3"
          :expand="true"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Coasting orbit"
          :path="['coastingOrbit']"
          :colorIndex="4"
        />
      </v-col>
    </div>
    <div
      class="d-flex"
      v-if="missionManager.dashboardTools().isStationKeepingLEOMission(results)"
    >
      <v-col cols="4">
        <exo-mission-display-stationkeepingleo-maneuver
          :missionManager="missionManager"
          :results="results"
          label="LEO Station Keeping"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-spacecraft
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="1"
          :expand="true"
        />
        <exo-mission-display-thruster
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="2"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Orbit"
          :path="['initialOrbit']"
          :expand="true"
          :colorIndex="3"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
    </div>
    <div
      class="d-flex"
      v-if="missionManager.dashboardTools().isDeorbitingMission(results)"
    >
      <v-col cols="4">
        <exo-mission-display-orbit-maneuver
          :missionManager="missionManager"
          :results="results"
          label="Deorbitation"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-spacecraft
          :missionManager="missionManager"
          :results="results"
          label="Spacecraft"
          :path="['spacecraft']"
          :colorIndex="1"
          :expand="true"
        />
        <exo-mission-display-thruster
          :missionManager="missionManager"
          :results="results"
          label="Propulsion system"
          :path="['spacecraft', 'thruster']"
          :colorIndex="2"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
      <v-col cols="4">
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['maneuver', 'initialOrbit']"
          :colorIndex="3"
          :expand="true"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Final orbit"
          :path="['maneuver', 'finalOrbit']"
          :colorIndex="4"
        />
      </v-col>
    </div>
    <div
      class="d-flex"
      v-if="missionManager.dashboardTools().isSequenceMission(results)"
    >
      <v-col cols="4">
        <exo-mission-display-mission-summary-card
          :missionManager="missionManager"
          :results="results"
          label="Summary"
          :path="[]"
          :colorIndex="0"
          :expand="true"
        />
        <exo-mission-display-orbit
          :missionManager="missionManager"
          :results="results"
          label="Initial orbit"
          :path="['initialOrbit']"
          :colorIndex="1"
        />
        <exo-costs-display
          :missionManager="missionManager"
          :results="results"
          label="Costs"
          :path="['costs']"
          :colorIndex="10"
          :expand="true"
        />
      </v-col>
      <v-col cols="8" p-2>
        <div style="height: 10px; background-color: #7faefa"></div>
        <v-tabs show-arrows>
          <v-tab
            v-for="(subMissionResults, index) in resultsBySubMission"
            :key="subMissionResults.id"
            ripple
            v-if="subMissionResults[0] != null"
          >
            {{ 'Mission ' + (index + 1) + ': ' + subMissionResults[0].type }}
          </v-tab>
          <v-tab-item
            v-for="subMissionResults in resultsBySubMission"
            :key="subMissionResults.id"
          >
            <v-card>
              <div
                v-if="
                  missionManager
                    .dashboardTools()
                    .isPositioningMission(subMissionResults)
                "
              >
                <v-row no-gutters p-4>
                  <v-col cols="6">
                    <exo-mission-display-orbit-maneuver
                      :isSubMission="true"
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Orbital Transfer"
                      :path="[]"
                      :colorIndex="4"
                      :expand="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <exo-mission-display-orbit
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Target orbit"
                      :path="['maneuver', 'finalOrbit']"
                      :colorIndex="5"
                      :expand="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <div
                v-if="
                  missionManager
                    .dashboardTools()
                    .isRAANMission(subMissionResults)
                "
              >
                <v-row no-gutters p-4>
                  <v-col cols="4">
                    <exo-mission-display-raan-maneuver
                      :isSubMission="true"
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="RAAN Phasing"
                      :path="[]"
                      :colorIndex="4"
                      :expand="true"
                    />
                  </v-col>
                  <v-col cols="4">
                    <exo-mission-display-orbit
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Coasting orbit"
                      :path="['initialManeuver', 'finalOrbit']"
                      :colorIndex="5"
                      :expand="true"
                    />
                  </v-col>
                  <v-col cols="4">
                    <exo-mission-display-orbit
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Target orbit"
                      :path="['finalManeuver', 'finalOrbit']"
                      :colorIndex="6"
                      :expand="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <div
                v-if="
                  missionManager
                    .dashboardTools()
                    .isArgumentOfLatitudePhasingMission(subMissionResults)
                "
              >
                <v-row no-gutters p-4>
                  <v-col cols="6">
                    <exo-mission-display-aolphasing-maneuver
                      :isSubMission="true"
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Orbit Phasing"
                      :path="[]"
                      :colorIndex="4"
                      :expand="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <exo-mission-display-orbit
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Coasting orbit"
                      :path="['coastingOrbit']"
                      :colorIndex="5"
                      :expand="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <div
                v-if="
                  missionManager
                    .dashboardTools()
                    .isStationKeepingLEOMission(subMissionResults)
                "
              >
                <v-row no-gutters p-4>
                  <v-col cols="12">
                    <exo-mission-display-stationkeepingleo-maneuver
                      :isSubMission="true"
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="LEO Station Keeping"
                      :path="[]"
                      :colorIndex="4"
                      :expand="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <div
                v-if="
                  missionManager
                    .dashboardTools()
                    .isDeorbitingMission(subMissionResults)
                "
              >
                <v-row no-gutters p-4>
                  <v-col cols="6">
                    <exo-mission-display-orbit-maneuver
                      :isSubMission="true"
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Deorbitation"
                      :path="[]"
                      :colorIndex="4"
                      :expand="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <exo-mission-display-orbit
                      :missionManager="missionManager"
                      :results="subMissionResults"
                      label="Target orbit"
                      :path="['maneuver', 'finalOrbit']"
                      :colorIndex="5"
                      :expand="true"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </div>
  </v-card-text>
</template>

<script>
/* eslint-disable vue/no-dupe-keys */
import dataTools from '../../tools/data.js'
import dataDescription from '../../tools/dataDescription.json'
import Vue from 'vue'
import tooltipCosts from '../../components/Tooltips/tooltipCosts'
import { mapGetters } from 'vuex'

let displayObjectCommon = {
  props: {
    missionManager: Object,
    results: Array,
    label: String,
    path: Array,
    colorIndex: Number,
    expand: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      context: 'ParametricStudyResult'
    }
  },

  methods: {
    getDisplayedString(field) {
      return this.missionManager.mergeString(
        this.path.concat(field[field.length - 1]),
        this.results
      )
    },

    isSensorExistInSpacecraft(sensorType) {
      for (let i = 0; i < this.missionManager.currentResultsLog.results.length; i++) {
        let spacecraft = this.missionManager.currentResultsLog.results[i].spacecraft
        for (let j = 0; j < spacecraft.sensors.length; j++) {
          let sensor = spacecraft.sensors[j]
          if (JSON.stringify(sensor.sensorType).includes(JSON.stringify(sensorType))) {
            return true
          }
        }
      }
      return false
    },

    getFieldValue(field) {
      let type = dataTools.getFieldTypeFromPath(
        field,
        this.context,
        this.missionManager.currentResultsLog.scriptConfig
      )
      if (type === '') {
        console.log('No type in result file for : ' + field)
        return ''
      }
      if (type === 'matrix') {
        return this.getDisplayedMatrixValue(this.results, this.path, field)
      } else if (type === 'vector') {
        return this.getDisplayedVectorValue(this.results, this.path, field)
      } else if (
        dataDescription[type] != null &&
        (dataDescription[type].type === 'int' ||
          dataDescription[type].type === 'double' ||
          dataDescription[type].type === 'integer')
      ) {
        return this.getDisplayedValueWithUnit(field)
      } else {
        return this.getDisplayedString(field)
      }
    },

    getFieldValueWithoutUnit(field) {
      let type = dataTools.getFieldTypeFromPath(
        field,
        this.context,
        this.missionManager.currentResultsLog.scriptConfig
      )
      if (type === '') {
        console.log('No type in result file for : ' + field)
        return ''
      }
      if (type === 'matrix') {
        return this.getDisplayedMatrixValue(this.results, this.path, field)
      } else if (type === 'vector') {
        return this.getDisplayedVectorValue(this.results, this.path, field)
      } else if (
        dataDescription[type] != null &&
        (dataDescription[type].type === 'int' ||
          dataDescription[type].type === 'double' ||
          dataDescription[type].type === 'integer')
      ) {
        return this.getDisplayedValueWithoutUnit(field)
      } else {
        return this.getDisplayedString(field)
      }
    },

    getDisplayedVectorValue(results, path, field) {
      let vector = '['
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      let unit = ''
      for (let dimension of fieldDescription.dimensions) {
        let currentField = JSON.parse(JSON.stringify(field))
        currentField.pop()
        currentField.push(dimension)
        vector += this.getFieldValueWithoutUnit(currentField)
        vector += ', '
        unit = this.getDisplayedUnit(currentField)
      }
      vector = vector.substring(0, vector.length - 2)
      vector += '] ' + unit
      return vector
    },

    getDisplayedVectorValueWithoutUnit(results, path, field) {
      let vector = '['
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      for (let dimension of fieldDescription.dimensions) {
        let currentField = JSON.parse(JSON.stringify(field))
        currentField.pop()
        currentField.push(dimension)
        vector += this.getFieldValueWithoutUnit(currentField)
        vector += ', '
      }
      vector = vector.substring(0, vector.length - 2)
      vector += ']'
      return vector
    },

    getDisplayedMatrixValue(results, path, field) {
      let matrix = '['
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      let unit = ''
      for (let dimension of fieldDescription.dimensions) {
        let currentField = JSON.parse(JSON.stringify(field))
        currentField.pop()
        currentField.push(dimension)
        unit = this.getDisplayedVectorUnit(this.results, path, currentField)
        matrix += this.getDisplayedVectorValueWithoutUnit(
          this.results,
          path,
          currentField
        )
        matrix += '\n'
      }
      matrix += '] ' + unit
      return matrix
    },

    getFieldLabel(field) {
      return dataTools.getFieldLabelFromPath(field, 'ParametricStudyResult')
    },

    getDisplayedValueWithoutUnit(field) {
      let range = this.missionManager.computeRange(
        dataTools.getFieldTypeFromPath(
          field,
          this.context,
          this.missionManager.currentResultsLog.scriptConfig
        ),
        this.path.concat(field[field.length - 1]),
        this.results
      )
      if (range === '') {
        return 'undefined'
      }
      return range
    },

    getDisplayedValueWithUnit(field) {
      let range = this.missionManager.computeRange(
        dataTools.getFieldTypeFromPath(
          field,
          this.context,
          this.missionManager.currentResultsLog.scriptConfig
        ),
        this.path.concat(field[field.length - 1]),
        this.results
      )
      if (range === '') {
        return 'undefined'
      }
      return (
        range +
        ' ' +
        dataTools.getUnitDisplayed(
          dataTools.getDefaultGuiUnit(
            dataTools.getFieldTypeFromPath(
              field,
              this.context,
              this.missionManager.currentResultsLog.scriptConfig
            )
          )
        )
      )
    },

    getDisplayedUnit(field) {
      let range = this.missionManager.computeRange(
        dataTools.getFieldTypeFromPath(
          field,
          this.context,
          this.missionManager.currentResultsLog.scriptConfig
        ),
        this.path.concat(field[field.length - 1]),
        this.results
      )
      if (range === '') {
        return 'undefined'
      }
      return dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(
          dataTools.getFieldTypeFromPath(
            field,
            this.context,
            this.missionManager.currentResultsLog.scriptConfig
          )
        )
      )
    },

    getDisplayedVectorUnit(results, path, field) {
      let unit = ''
      let fieldDescription = dataTools.getResultFieldFromPath(
        field,
        this.context
      )
      for (let dimension of fieldDescription.dimensions) {
        unit = this.getDisplayedUnit(path.concat(dimension))
      }
      return unit
    },

    getColor(index) {
      return this.getCardColors()[index]
    },

    getCardColors() {
      return [
        '#ff948c',
        '#ffb58c',
        '#ffd18c',
        '#8cffff',
        '#8ce7ff',
        '#8cceff',
        '#938cff',
        '#c78cff',
        '#ff8ca8',
        '#ff8c8c',
        '#a5ffd9'
      ]
    },

    displayData(field) {
      return !this.getFieldValue(field).toString().includes('undefined')
    }
  }
}

Vue.component('exo-mission-display-adcs', {
  mixins: [displayObjectCommon],

  template: `
  <exo-mission-display-card label="ADCS Design results" :colorIndex="colorIndex" :expand="expand">
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['date']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['atmosphericDensity']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['initialLtan']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['controllabilityDurationThrusterOn']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['achievableDutyCycle']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['desaturationDurationThrusterOff']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['fullDesaturationDurationThrusterOff']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['controllabilityDurationThrusterOff']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['detumbleDuration']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxThrusterTorque']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxResidualMagneticTorque']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxSolarRadiationPressureTorque']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxDragTorque']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('ANTENNA')" :missionManager="missionManager" :results="results" :path="path" :field="['antennaGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('ANTENNA')" :missionManager="missionManager" :results="results" :path="path" :field="['antennaManeuverValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('GPS')" :missionManager="missionManager" :results="results" :path="path" :field="['gpsGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('GPS')" :missionManager="missionManager" :results="results" :path="path" :field="['gpsManeuverValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('SUN_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['sunSensorGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('SUN_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['sunSensorManeuverValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('EARTH_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['earthSensorGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('EARTH_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['earthSensorManeuverValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('IR_EARTH_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['irEarthSensorGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('IR_EARTH_SENSOR')" :missionManager="missionManager" :results="results" :path="path" :field="['irEarthSensorManeuverValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('STAR_TRACKER')" :missionManager="missionManager" :results="results" :path="path" :field="['starTrackerGlobalValidity']"/>
    <exo-mission-display-field v-if="isSensorExistInSpacecraft('STAR_TRACKER')" :missionManager="missionManager" :results="results" :path="path" :field="['starTrackerManeuverValidity']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['allSensorGlobalValidity']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['allSensorManeuverValidity']"/>
  </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-magnetic-torquer', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getMagneticTorquerObject()
  },

  computed: {
    ...mapGetters({ currentMission: 'currentMission' })
  },

  data() {
    return {
      type: 'analyticalMagneticTorquer',
      magneticTorquerObject: null
    }
  },

  methods: {
    getMagneticTorquerObject() {
      this.magneticTorquerObject =
        this.currentMission.spacecraft.magneticTorquers
    }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <v-expansion-panels>
        <v-expansion-panel
          v-for="(magneticTorquer,index) in this.magneticTorquerObject"
          :key="magneticTorquer.id"
        >
          <v-expansion-panel-header>
            <div>{{magneticTorquer.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <exo-mission-display-analyticalMagneticTorquer-withoutPanel :missionManager="missionManager" :results="results" :path="['spacecraft', 'magneticTorquers',index]" :label="magneticTorquer.name"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
   </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-analyticalMagneticTorquer', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'analyticalMagneticTorquer' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['magneticDipoleMoment']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['onTime']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['positionInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['directionInSpacecraftFrame']"/>
  </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-analyticalMagneticTorquer-withoutPanel', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'analyticalMagneticTorquer' }
  },

  template: `
  <v-list dense class="p-0">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['magneticDipoleMoment']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['onTime']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['positionInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['directionInSpacecraftFrame']"/>
  </v-list>
  `
})

Vue.component('exo-mission-display-reaction-wheel', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getReactionWheelObject()
  },

  computed: {
    ...mapGetters({ currentMission: 'currentMission' })
  },

  data() {
    return {
      type: 'reactionWheelDefinition',
      reactionWheelObject: null
    }
  },

  methods: {
    getReactionWheelObject() {
      this.reactionWheelObject = this.currentMission.spacecraft.reactionWheels
    }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <v-expansion-panels>
        <v-expansion-panel
          v-for="(reactionWheel,index) in this.reactionWheelObject"
          :key="reactionWheel.id"
        >
          <v-expansion-panel-header>
            <div>{{reactionWheel.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <exo-mission-display-reactionWheel-withoutPanel :missionManager="missionManager" :results="results" :path="['spacecraft', 'reactionWheels',index]" :label="reactionWheelObject.name"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
   </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-reactionWheel-withoutPanel', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'reactionWheelDefinition' }
  },

  template: `
  <v-list dense class="p-0">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxTorque']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxAngularMomentum']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['nominalCapacity']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['positionInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['directionInSpacecraftFrame']"/>
  </v-list>
  `
})

Vue.component('exo-mission-display-sensor', {
  mixins: [displayObjectCommon],

  mounted() {
    this.getSensorObject()
  },

  computed: {
    ...mapGetters({ currentMission: 'currentMission' })
  },

  data() {
    return {
      type: 'analyticalSensor',
      sensorObject: null
    }
  },

  methods: {
    getSensorObject() {
      this.sensorObject = this.currentMission.spacecraft.sensors
    }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <v-expansion-panels>
        <v-expansion-panel
          v-for="(sensor,index) in this.sensorObject"
          :key="sensor.id"
        >
          <v-expansion-panel-header>
            <div>{{sensor.name}}</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <exo-mission-display-sensor-withoutPanel :missionManager="missionManager" :results="results" :path="['spacecraft', 'sensors',index]" :label="sensorObject.name"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
   </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-sensor-withoutPanel', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'analyticalSensor' }
  },

  template: `
  <v-list dense class="p-0">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['sensorType']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['fieldOfView']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['directionInSpacecraftFrame']"/>
  </v-list>
  `
})

Vue.component('exo-mission-display-field', {
  mixins: [displayObjectCommon],

  props: ['path', 'field'],

  template: `
  <v-list-item v-if="this.displayData(path.concat(field))">
    <v-row no-gutters>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col>
            <v-list-item-content>{{ getFieldLabel(path.concat(field)) }}</v-list-item-content>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1">
        <v-divider vertical></v-divider>
      </v-col>
      <v-col cols="5">
        <v-row no-gutters>
          <v-col>
            <v-list-item-content class="justify-end text-right">{{ getFieldValue(path.concat(field)) }}</v-list-item-content>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-list-item>
  `
})

Vue.component('exo-mission-display-card', {
  mixins: [displayObjectCommon],
  props: {
    label: String,
    expand: Boolean
  },

  data() {
    return {
      expandPanel: this.expand
    }
  },

  template: `
  <v-col m-2>
    <v-card height="100%">
      <div v-bind:style="{ 'background-color': getColor(colorIndex)}"  style="height: 10px"></div>
      <v-card-title :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
        <v-row dense align="center" no-gutters>
          <v-col cols="10">
            <h5>{{ label }}</h5>
          </v-col>
          <v-col cols="1">
            <slot name="helpDialog"></slot>
          </v-col>
        </v-row>

        <v-btn icon v-on:click="expandPanel = !expandPanel">
          <v-icon color="grey darken-1" v-if="expandPanel">expand_less</v-icon>
          <v-icon color="grey darken-1" v-if="!expandPanel">expand_more</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="m-0" v-if="expandPanel"></v-divider>

      <v-list v-if="expandPanel" dense class="p-0">
         <slot></slot>
      </v-list>
    </v-card>
  </v-col>
  `
  // TODO MFI on click copy content to clipboard
})

Vue.component('exo-mission-display-orbit', {
  mixins: [displayObjectCommon],

  data() {
    return {
      type: 'orbit'
    }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['type']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['altitude']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['semiMajorAxis']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['sunSynchronousOrbit']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['inclination']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['keplerianPeriod']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanNodalPeriod']"/>
      <exo-mission-display-field v-if="missionManager.dashboardTools().isRAANMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['raanDriftRate']"/>
      <exo-mission-display-field v-if="missionManager.dashboardTools().isRAANMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['ltanDriftRate']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanMotion']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['velocity']"/>
  </exo-mission-display-card>
  `,

  methods: {
    isElliptical() {
      return this.missionManager.isStringInside(
        'Elliptical',
        this.path.concat(['type']),
        this.results
      )
    }
  }
})

Vue.component('exo-mission-display-spacecraft', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'spacecraft' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['platformMass']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['dragArea']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['dragCoefficient']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['orbitalAveragePower']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['orbitalDutyCycle']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanDutyCycle']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['inertialCenterInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['inertialMatrix']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['absorptionCoefficient']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['reflectionCoefficient']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['aerodynamicCenterInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['solarRadiationPressureCenterInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['minAngularRate']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxAngularRate']"/>
      <exo-mission-display-analyticalMagneticTorquer v-if="missionManager.dashboardTools().isADCSMission(results)" :missionManager="missionManager" :results="results" :path="['spacecraft','residualMagneticMoment']" label="Residual magnetic moment"/>
  </exo-mission-display-card>
  `
})

Vue.component('exo-mission-display-thruster', {
  mixins: [displayObjectCommon],

  data() {
    return { type: 'thruster' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['name']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['thrust']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['isp']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['power']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['standbyPower']"/>
      <!-- <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['warmUpDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['warmUpPower']"/> -->
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['electricalEfficiency']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalMass']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['initPropellantMass']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalImpulse']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['finalPropellantMass']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['cost']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['positionInSpacecraftFrame']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['directionInSpacecraftFrame']"/>
  </exo-mission-display-card>
  `
})

Vue.component('exo-mission-help-terms', {
  template: `
      <exo-help-dialog margin='m-0' title="Mission, manoeuvres and burns">
               A <b>mission</b> is composed of one or several manoeuvres.<br/>
               A <b>manoeuvre</b> is the transfer from one orbit to another, a waiting time can be observed between manoeuvres.<br/>
               Multiple <b>burns</b> can occurs to perform a manoeuvre. <br/>
               When the duty cycle is 100%, there is one single burn during the whole manoeuvre.
               When the duty cycle is lower than 100%, the are two burns per orbital period.
               <br>
        </exo-help-dialog>
   `
})

Vue.component('exo-mission-display-orbit-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    },
    maneuverType: {
      type: String,
      default: 'maneuver'
    }
  },

  data() {
    return { type: 'maneuver' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
    <exo-mission-help-terms/>
    </template>
    <exo-mission-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>

    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="['maneuver',...path]" :field="['deltaSemiMajorAxis']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="['maneuver',...path]" :field="['deltaInclination']"/>
  </exo-mission-display-card>
    `
})

Vue.component('exo-mission-display-raan-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'raanPhasing' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
    <exo-mission-help-terms/>
    </template>
    <exo-mission-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['dragPerturbationEnabled']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['deltaRaan']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['initialManeuverDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['finalManeuverDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingAltitude']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingInclination']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaRaan']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaLtan']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['targetDeltaVmax']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['targetMissionDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['minCoastingAltitude']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxCoastingAltitude']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['minCoastingInclination']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maxCoastingInclination']"/>
      
  </exo-mission-display-card>
   `
})

Vue.component('exo-mission-display-aolphasing-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'aolPhasing' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
    <exo-mission-help-terms/>
    </template>
    <exo-mission-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>

      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingDuration']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['deltaSma']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['deltaArgumentOfLatitude']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maneuveringArgumentOfLatitudeDrift']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingArgumentOfLatitudeDrift']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['coastingDriftRate']"/>
      
  </exo-mission-display-card>
   `
})

Vue.component('exo-mission-display-stationkeepingleo-maneuver', {
  mixins: [displayObjectCommon],
  props: {
    isSubMission: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { type: 'stationKeepingLeo' }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
    <exo-mission-help-terms/>
    </template>
    <exo-mission-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['density']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['customSolarFlux']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['smaTolerance']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['alongTrackTolerance']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maneuverCount']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['durationBetweenManeuvers']"/>
      <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['averageManeuverDuration']"/>
     

  </exo-mission-display-card>
   `
})

Vue.component('exo-mission-display-mission-summary-card', {
  mixins: [displayObjectCommon],

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
    <exo-mission-help-terms/>
    </template>

    <exo-mission-display-mission-summary-fields :missionManager="missionManager" :results="results" :path="path"/>
  </exo-mission-display-card>
    `
})

Vue.component('exo-mission-display-mission-summary-fields', {
  mixins: [displayObjectCommon],

  template: `
<div>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['deltaV']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['usedPropellant']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['missionDuration']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['thrustDuration']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maneuveringDuration']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['thrusterMeanDutyCycle']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalImpulse']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['numberOfBurns']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanBurnDurationEstimation']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['maneuverModel']"/>
  <exo-mission-display-field v-if="missionManager.dashboardTools().isSequenceMission(results)" :missionManager="missionManager" :results="results" :path="path" :field="['totalMassLossAfterSubMissions']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanAtmosphericDensity']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanDragAcceleration']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['meanDrag']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['dragDeltaV']"/>
  <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['dragToThrustRatio']"/>
</div>
    `,

  data() {
    return { type: '' }
  }
})

Vue.component('exo-costs-display', {
  mixins: [displayObjectCommon],

  components: {
    tooltipCosts
  },

  data() {
    return {
      type: 'costs',
      tooltipImgPath: require('../../assets/images/tooltip-costs.png')
    }
  },

  template: `
  <exo-mission-display-card :label="label" :colorIndex="colorIndex" :expand="expand">
    <template v-slot:helpDialog>
      <exo-help-dialog title="Cost functions" margin="m-0">
        <tooltipCosts />
      </exo-help-dialog>
    </template>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalMissionCostExcludingPlatformLaunch']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalMissionCostIncludingPlatformLaunch']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalPropulsionCost']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['totalThrusterCost']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['durationCost']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['massCost']"/>
    <exo-mission-display-field :missionManager="missionManager" :results="results" :path="path" :field="['thrusterCost']"/>
    </exo-mission-display-card>
  `
})

export default {
  name: 'analytical-result-display',

  props: ['missionManager', 'results'],

  computed: {
    resultsBySubMission() {
      let subMissions = []
      if (this.results.length > 0) {
        for (let i = 0; i < this.results[0].subMissions.length; i++) {
          // group all results for this sub mission
          subMissions[i] = this.results.map((result) => result.subMissions[i])
        }
      }
      return subMissions
    }
  },

  data() {
    return {}
  }
}
</script>
